import createBrowserHistory from 'history/createBrowserHistory';

export default createBrowserHistory({});



// WEBPACK FOOTER //
// ./src/history.js